import { createContext } from "react";

const JarvisContext = createContext({});

export default JarvisContext;
